import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { AutoDisabler, Validate, ValidationGroup } from "mui-validate";
import UserDataService from "../../../services/UserService";
import LocationDataService from "../../../services/LocationService";
import DepartmentDataService from "../../../services/DepartmentService";
import MenuItem from "@material-ui/core/MenuItem";
import { Grid } from "@material-ui/core";
import { useMediaQuery } from "@mui/material";
import { styled, ThemeProvider } from "@mui/system";
import { createTheme } from "@mui/material/styles";
import { useStyles } from "../../styles/useStyles";

const theme = createTheme();

require("dotenv").config();

// Style for consistent card height
const StyledCard = styled(Card)({
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const StyledCardContent = styled(CardContent)({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
});

function AddUserForm() {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    retrieveLocations();
  }, []);

  const retrieveLocations = () => {
    LocationDataService.getAll()
      .then((response) => {
        setLocations(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [departments, setDepartments] = useState([]);

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );
  const [userLevel] = React.useState(localStorage.getItem("level"));
  const isAdmin = userLevel === "admin";

  useEffect(() => {
    retrieveDepartments();
  }, []);

  const retrieveDepartments = () => {
    DepartmentDataService.adminAll()
      .then((response) => {
        setDepartments(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const initialUserState = {
    id: null,
    sap: "",
    name: "",
    loc_number: 1,
    status: 3,
    loc_name: process.env.REACT_APP_HOTEL_NAME,
    sub_loc_name: "Служител",
    pin: null,
    email: "",
    phone: "",
    address: "",
    staff: true,
  };

  const [user, setUser] = useState(initialUserState);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const saveUser = () => {
    var data = {
      name: user.name,
      loc_number: user.loc_number,
      loc_name: user.loc_name,
      sub_loc_name: user.sub_loc_name,
      status: user.status,
      sap: Math.random()
        .toString()
        .substr(2, 4),
      pin: user.pin,
      // email: user.email,
      // phone: user.phone,
      // address: user.address,
      staff: user.staff,
    };

    UserDataService.create(data)
      .then((response) => {
        setUser({
          id: response.data.id,
          name: response.data.name,
          loc_number: response.data.loc_number,
          loc_name: response.data.loc_name,
          sub_loc_name: response.data.sub_loc_name,
          status: response.data.status,
          sap: response.data.sap,
          pin: response.data.pin,
          // email: response.data.email,
          // phone: response.data.phone,
          // address: response.data.address,
          staff: response.data.staff,
        });
        setSubmitted(true);
        console.log(response.data);
        setTimeout(function() {
          window.location.reload(1);
        }, 2000);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const newUser = () => {
    setUser(initialUserState);
    setSubmitted(false);
  };

  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const classes = useStyles();

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <ThemeProvider theme={theme}>
      <StyledCard className={classes.item}>
        <AppBar position="static" elevation={0} color="primary">
          <Toolbar className="px-8">
            <Typography
              variant="subtitle1"
              color="inherit"
              className="flex-1 px-12"
            >
              1. {isAdmin ? "Създаване на Служител/Гост" : "Създаване на Гост"}
            </Typography>
          </Toolbar>
        </AppBar>
        <StyledCardContent>
          <div className="submit-form">
            {submitted ? (
              <div>
                <Alert
                  severity="success"
                  style={{ marginBottom: "15px" }}
                  onClose={() => setSubmitted(false)}
                >
                  Успешно създаден потребител!
                </Alert>
                <Button onClick={newUser} color="primary" variant="outlined">
                  Създай нов потребител
                </Button>
              </div>
            ) : (
              <ValidationGroup>
                <form className={classes.root}>
                  <Grid container spacing={1}>
                    <Grid item xs={isSmallScreen ? 12 : 6}>
                      <Validate
                        name="name"
                        required={[true, "This field is required!"]}
                      >
                        <TextField
                          required
                          id="outlined-required name"
                          label="Име"
                          variant="outlined"
                          name="name"
                          value={user.name}
                          onChange={handleInputChange}
                          size="small"
                          fullWidth
                        />
                      </Validate>
                    </Grid>
                    <Grid item xs={isSmallScreen ? 12 : 6}>
                      <Validate
                        name="sub_loc_name"
                        required={[true, "This field is required!"]}
                      >
                        <TextField
                          id="outlined-select-sub-location sub_loc_name"
                          select
                          name="sub_loc_name"
                          label="Отдел"
                          value={user.sub_loc_name}
                          onChange={handleInputChange}
                          size="small"
                          variant="outlined"
                          fullWidth
                        >
                          {departments.map((department) => (
                            <MenuItem
                              key={department.id}
                              value={department.name}
                            >
                              {department.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Validate>
                    </Grid>

                    <Grid item xs={12}>
                      <AutoDisabler>
                        <Button
                          onClick={saveUser}
                          variant="contained"
                          color="primary"
                        >
                          Създай Потребител
                        </Button>
                      </AutoDisabler>
                    </Grid>
                  </Grid>
                </form>
              </ValidationGroup>
            )}
          </div>
        </StyledCardContent>
      </StyledCard>
    </ThemeProvider>
  );
}

export default AddUserForm;
